module.exports = __webpack_public_path__ + "img/组 7@2x.76e38fac.png";